// Matches TextSession.SessionType names on the backend
export const SESSION_TYPE_LABELS = {
  sms: 'SMS',
  convey: 'Convey',
  rcs: 'RCS',
  sms_admin: 'SMS Admin',
  tcapi: 'TT911',
  interagency: 'Interagency',
  default: 'Default',
} as const;

// convey and default are deprecated/legacy — exclude them from the filter UI
export const SESSION_TYPES = Object.entries(SESSION_TYPE_LABELS)
  .filter(([value]) => value !== 'convey' && value !== 'default')
  .map(([value, label]) => ({ value, label }));
